import React, { useEffect, useState, useRef } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { ManageBranchOffers, ManageCategory, ManageOffers, ManageRestaurant, showMessage, validURL, sleep } from "../../Functionalities/Functions";
import AddTopComponent from '../../CoreComponents/AddTopComponent'
import AddBottomComponent from '../../CoreComponents/AddBottomComponent'
import Dropdown from "../../CoreComponents/Dropdown";
import { ManageSection } from "./Logic";
import AdvancedSelctionModal from "../../CoreComponents/AdvancedSelectionModal";
import { protocol, token, is_superuser, picked_franchise_id, sees_all_franchises } from "../../Functionalities/Config";
import { ManageFranchise } from "../Franchise/Logic";
import axios from "axios";
import { HomeSlotSelect, slotAllowed } from "./homeSlots";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";

function Body() {
  const [disable, setdisable] = useState(false)
  const [imageError, setImageError] = useState(false)
  const [data, setData] = useState({
    id: "",
    name: "",
    visible_from: "",
    visible_to: "",
    icon: "",
    url_link: "",

    slot: "NONE",
    image_type: "", // ADS_IMAGE ,BANNER, SQUARE_BANNER, REGULAR_IMAGE

    section_type: "OFFER", //OFFER, REGULAR, ADS
    object_type: "BRANCH",//ITEM_OFFER, BRANCH_OFFER, BRANCH, ITEM

    offer_items: [],
    offer_branches: [],
    branches: [],

    branch: "",
    product: "",
    ids: [],
    franchise_id: picked_franchise_id,
  });
  const [franchises, setFranchises] = useState([]);
  const [offer_items, setOffer_items] = useState([]);
  const [itemOfferNext, setItemOfferNext] = useState()
  const [itemOfferPrev, setItemOfferPrev] = useState()
  const [offer_branches, setOffer_branches] = useState([]);
  const [branchOfferNext, setBranchOfferNext] = useState()
  const [branchOfferPrev, setBranchOfferPrev] = useState()
  const [branches, setBranches] = useState([]);
  const [branchNext, setBranchNext] = useState()
  const [branchPrev, setBranchPrev] = useState()

  const [ids, setIds] = useState([]);
  const [selectedData, setSelectedData] = useState([]);

  const [loading, setloading] = useState(true);
  const [key, setKey] = useState(new Date());
  const [errors, setErrors] = useState([]);
  const [searchText, setSearchText] = useState("")


  useEffect(() => {
    if (!sees_all_franchises) return;
    ManageFranchise("", "", "get", "page_wise=false&for_dropdown=true")
      .then((res) => setFranchises(Array.isArray(res?.data) ? res.data : []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchProductOfferData();
    fetchBranchOfferData();
    fetchBranches();
  }, [ids, searchText]);

  const setSearchToState = (val) => {
    setSearchText(val)
  }



  useEffect(() => {
    if (errors.length > 0) { showMessage(errors[0], "danger", "Following fields required!", "top", "top-right", 0); }
  }, [errors]);

  function Push(id, name) {
    if (!ids.includes(id)) {

      setIds(prev => [...prev, id])
      setSelectedData(prev => [...prev, { id: id, name: name }])
      var x = prev => [...prev, id]
      var y = prev => [...prev, { id: id, name: name }]
      showMessage("Added successfully", "info", "Success!", "top", "top-right", 0)
      setData({ ...data, ids: [...ids, id] })
      // props.customerFunction(x)
      // props.nameFunction(y)
      // setOffer_items([])
      // setOffer_branches([])
      // setBranches([])
    }
    else {
    }

  }

  function Pop(index) {
    var array = selectedData
    array.splice(index, 1)

    var arrayid = ids
    arrayid.splice(index, 1)
    var x = []
    x = array
    // void 0
    setSelectedData([])
    // setData({ ...data, inner_category: [] })
    array.map((arr) => {
      setSelectedData(prev => [...prev, { id: arr.id, name: arr.name }])
    })
    setIds([])
    arrayid.map((arr) => {
      setIds(prev => [...prev, arr])
    })
    // console.warn("pop")
    setData({ ...data, ids: arrayid })


    showMessage("removed successfully", "info", "Success!", "top", "top-right", 0)
  }

  const fetchProductOfferData = () => {
    // showMessage("Loading offer products", "info", "Loading", "bottom", "bottom-left", 0);

    let params = "exclude_list=[" + ids + "]&for_dropdown=true&offer_type=item&sections_offers=true";
    if (searchText) {
      params = params + '&search_text=' + searchText
    }
    let result = ManageOffers("", "", "get", params);
    result.then((result) => {
      setOffer_items([])
      if (result.data.results?.length > 0) {
        setOffer_items(result.data.results)
        setItemOfferNext(result.data.next)
        setItemOfferPrev(result.data.prev)
        // setData({
        //   ...data,
        //   offer_items: result.data,
        // });
        setloading(false);
      }
    });
  };

  const fetchBranchOfferData = () => {
    // showMessage("Loading offer restaurants", "info", "Loading", "bottom", "bottom-left", 0);

    // return 0;exclude_list=['heading']&
    let params = "exclude_list=[" + ids + "]&for_dropdown=true&offer_type=branch&sections_offers=true";
    if (searchText) {
      params = params + '&search_text=' + searchText
    }
    let result = ManageBranchOffers("", "", "get", params);

    result.then((result) => {
      setOffer_branches([])
      if (result.data.results?.length > 0) {
        setOffer_branches(result.data.results)
        setBranchOfferNext(result.data.next)
        setBranchOfferPrev(result.data.prev)

        // setData({
        //   ...data,
        //   offer_branches: result.data,
        // });
        setloading(false);
      }
      setloading(false);
    });
  };

  const fetchBranches = () => {
    // showMessage("Loading Restaurant", "info", "Loading", "bottom", "bottom-left", 0);

    let params = "exclude_list=[" + ids + "]&for_drop_down=true&blocked_out_drop_down=1&order_by_name=true";

    if (searchText) {
      params = params + '&search_text=' + searchText;
    }

    let result = ManageRestaurant("", "", "get", params);
    result.then((result) => {
      setBranches([])
      if (result.data.results?.length > 0) {
        setBranches(result.data.results)
        setBranchNext(result.data.next)
        setBranchPrev(result.data.prev)
        // setData({
        //   ...data,
        //   branches: result.data,
        // });
        setloading(false);
        
      }
      setloading(false);

    }).catch((err) => {
      showMessage(JSON.stringify(err), "danger", "Loading error", "top", "top-center", 0);
    });
  };


  const handleBranchPrev = () => {
    var config = {
      method: "get",
      url: branchPrev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: token,
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setBranches(response.data.results)
        setBranchNext(response.data.next)
        setBranchPrev(response.data.prev)
      })
      .catch(function (error) {
        // void 0
      });
  }

  const handleBranchNext = () => {
    var config = {
      method: "get",
      url: branchNext.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: token,
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setBranches(response.data.results)
        setBranchNext(response.data.next)
        setBranchPrev(response.data.prev)
      })
      .catch(function (error) {
        // void 0
      });
  }

  const handleBranchOfferPrev = () => {
    var config = {
      method: "get",
      url: branchOfferPrev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: token,
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setOffer_branches(response.data.results)
        setBranchOfferNext(response.data.next)
        setBranchOfferPrev(response.data.prev)
      })
      .catch(function (error) {
        // void 0
      });
  }

  const handleBranchOfferNext = () => {
    var config = {
      method: "get",
      url: branchOfferNext.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: token,
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setOffer_branches(response.data.results)
        setBranchOfferNext(response.data.next)
        setBranchOfferPrev(response.data.prev)
      })
      .catch(function (error) {
        // void 0
      });
  }


  const handleItemOfferPrev = () => {
    var config = {
      method: "get",
      url: itemOfferPrev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: token,
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setOffer_items(response.data.results)
        setItemOfferPrev(response.data.prev)
        setItemOfferNext(response.data.next)
      })
      .catch(function (error) {
        // void 0
      });
  }

  const handleItemOfferNext = () => {
    var config = {
      method: "get",
      url: itemOfferNext.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: token,
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setOffer_items(response.data.results)
        setItemOfferPrev(response.data.prev)
        setItemOfferNext(response.data.next)
      })
      .catch(function (error) {
        // void 0
      });
  }

  const [compression, setCompression] = useState(false)


  const ref = useRef();

  const reset = () => {
    ref.current.value = "";
  };

  return (
    <div class="content-body">
      <div class="container-fluid">
        <AddTopComponent path={"sections"} />
        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="basic-form">
                <form
                // onSubmit={callAddCategory(data)}
                >
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Choose Type<span className="required">*</span></label>
                    <div className="col-sm-9">
                      <button disabled={false}
                        className={`submit btn  mr-2 ${data.section_type === "OFFER" ? 'btn-primary' : 'btn-light'}`}
                        name="OFFER"
                        onClick={(e) => { e.preventDefault(); setData({ ...data, section_type: e.target.name, object_type: "BRANCH", image_type: data.section_type === "SALE" ? "" : data.image_type }); setSelectedData([]); setIds([]); }}
                      >Banner</button>
                      <button disabled={false}
                        className={`submit btn  mr-2 ${data.section_type === "REGULAR" ? 'btn-primary' : 'btn-light'}`}
                        name="REGULAR"
                        onClick={(e) => { e.preventDefault(); setData({ ...data, section_type: e.target.name, object_type: "BRANCH", image_type: data.section_type === "SALE" ? "" : data.image_type }); setSelectedData([]); setIds([]); }}
                      >Regular</button>
                      <button disabled={false}
                        className={`submit btn  mr-2 ${data.section_type === "ADS" ? 'btn-primary' : 'btn-light'}`}
                        name="ADS"
                        onClick={(e) => { e.preventDefault(); setData({ ...data, section_type: e.target.name, object_type: "ADS", image_type: data.section_type === "SALE" ? "" : data.image_type }) }}
                      >Ads</button>
                      <button disabled={false}
                        className={`submit btn  mr-2 ${data.section_type === "SALE" ? 'btn-primary' : 'btn-light'}`}
                        name="SALE"
                        onClick={(e) => { e.preventDefault(); setData({ ...data, section_type: "SALE", object_type: "SALE", image_type: "" }); setSelectedData([]); setIds([]); }}
                      >Sale</button>

                    </div>
                  </div>

                  {data.section_type === "OFFER" &&
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Choose Restaurant / food <span className="required">*</span></label>
                      <div className="col-sm-9">
                        <button disabled={false}
                          className={`submit btn  mr-2 ${data.object_type === "BRANCH" ? 'btn-primary' : 'btn-light'}`} name="BRANCH"
                          onClick={(e) => { e.preventDefault(); setData({ ...data, object_type: e.target.name }); setSelectedData([]); setIds([]); }}
                        >Restaurant </button>
                        <button disabled={false}
                          className={`submit btn  mr-2 ${data.object_type === "ITEM" ? 'btn-primary' : 'btn-light'}`} name="ITEM"
                          onClick={(e) => { e.preventDefault(); setData({ ...data, object_type: e.target.name }); setSelectedData([]); setIds([]); }}
                        >Item</button>
                      </div>
                    </div>
                  }


                  {data.section_type !== "ADS" && <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Section Heading<span className="required">*</span></label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" value={data.name} onChange={(e) => setData({ ...data, name: e.target.value })} />
                    </div>
                  </div>}

                  {data.section_type === "ADS" && <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Url (https://www.example.com) </label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" value={data.url_link} onChange={(e) => setData({ ...data, url_link: e.target.value })} />
                    </div>
                  </div>}

                  {data.section_type === "SALE" && sees_all_franchises && <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Franchise<span className="required">*</span></label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        value={data.franchise_id}
                        onChange={(e) => setData({ ...data, franchise_id: e.target.value })}
                      >
                        <option value="">--Select Franchise--</option>
                        {franchises.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                      </select>
                    </div>
                  </div>}

                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Show between</label>
                    <div className="col-sm-9 d-flex align-items-center" style={{ gap: 10 }}>
                      <input
                        type="time"
                        className="form-control"
                        style={{ maxWidth: 160 }}
                        value={data.visible_from || ""}
                        onChange={(e) => setData({ ...data, visible_from: e.target.value })}
                      />
                      <span>and</span>
                      <input
                        type="time"
                        className="form-control"
                        style={{ maxWidth: 160 }}
                        value={data.visible_to || ""}
                        onChange={(e) => setData({ ...data, visible_to: e.target.value })}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => setData({ ...data, visible_from: "", visible_to: "" })}
                      >
                        Always on
                      </button>
                    </div>
                    <div className="col-sm-9 offset-sm-3">
                      <small className="text-muted">
                        Leave both blank to show it all day. An end time earlier than the
                        start time runs past midnight, for example 22:00 and 02:00.
                      </small>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">{data.section_type === "ADS" ? "Ads Image" : "Icon(1:1)"}  <span className="required">*</span>
                    <br/>
                    <b>Compress {data.section_type == 'ADS' ? "image" : "icon"} {" "}</b>
                    <input type="checkbox" checked={compression} onChange={(e) => {setCompression(e.target.checked);setData({...data,icon:""})}}/> 
                    </label>
                    <div className="col-sm-9">
                      <ImageUploadWithCrop
                        value={data.icon}
                        onChange={(file) => {
                          if (file) {
                            setData({ ...data, icon: file });
                            setImageError(false);
                          } else {
                            setData({ ...data, icon: "" });
                            setImageError(true);
                          }
                        }}
                        aspectRatio={1}
                        compress={compression}
                        compressMaxRes={data.section_type === "ADS" ? 486 : 33}
                      />
                      {imageError && <span className="required fs-14">Please change image</span>}
                    </div>
                  </div>



                  <div class="form-group row">
                    <label className="col-sm-3 col-form-label">Image Type
                      <span className="required">*</span>
                    </label>
                    <div class="col-sm-9">
                      <select
                        value={data.image_type}
                        class="form-control form-control-lg  "
                        onChange={(e) => {
                          setData({ ...data, image_type: e.target.value, slot: slotAllowed(data.slot, e.target.value) ? data.slot : "NONE" })
                        }}>
                        <option value={""}>--Select Image Type--</option>
                        {data.section_type === "ADS" && <option value={"ADS_IMAGE"}>Advertisement</option>}
                        {(data.section_type === "OFFER" || data.section_type === "SALE") && <option value={"BANNER"}>Banner type</option>}
                        {(data.section_type === "OFFER" || data.section_type === "SALE") && <option value={"SQUARE_BANNER"}>Square type</option>}
                        {data.section_type === "REGULAR" && <option value={"REGULAR_IMAGE"}>Normal listing</option>}
                      </select></div>
                  </div >



                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Home slot</label>
                    <div className="col-sm-9">
                      <HomeSlotSelect
                        value={data.slot}
                        imageType={data.image_type}
                        onChange={(slot) => setData({ ...data, slot })}
                      />
                    </div>
                  </div>

                  {data.section_type !== "ADS" && data.section_type !== "SALE" && <button type="button" class="btn btn-primary light form-control mb-2 mb-2" data-toggle="modal" data-target="#AdvancedSelctionModal">
                    Select {data.section_type === "REGULAR" ? data.object_type === "ITEM" ? "Item" : "Restaurants" : data.object_type === "ITEM" ? "Item" : "Restaurants"}
                  </button>}

                  <AdvancedSelctionModal
                    Push={Push}
                    Pop={Pop}
                    setSearchToState={setSearchToState}
                    propData={
                      data.section_type === "REGULAR" ?
                        (data.object_type === "ITEM" ?
                          [] : branches
                        )
                        :
                        data.object_type === "BRANCH" ?
                          offer_branches
                          :
                          offer_items
                    }
                    setSearch={searchText}
                    section_type={data.section_type}
                    object_type={data.object_type}
                    handleNext={() => {
                      if (data.section_type === "REGULAR") {
                        if (data.object_type == "ITEM") {
                          //no op
                        } else {
                          handleBranchNext()
                        }
                      } else {
                        if (data.object_type == 'BRANCH') {
                          //branch
                          handleBranchOfferNext()
                        } else {
                          //items
                          handleItemOfferNext()
                        }
                      }
                    }}

                    handlePrev={() => {
                      if (data.section_type === "REGULAR") {
                        if (data.object_type == "ITEM") {

                        } else {
                          handleBranchPrev()
                        }
                      } else {
                        if (data.object_type == 'BRANCH') {
                          //branch
                          handleBranchOfferPrev()
                        } else {
                          //items
                          handleItemOfferPrev()
                        }
                      }
                    }}
                    nextValid={() => {
                      if (data.section_type === "REGULAR") {
                        if (data.object_type == "ITEM") {
                          //no op
                          return false
                        } else {
                          if (!branchNext) {
                            return false
                          } else {
                            return true
                          }
                        }
                      } else {
                        if (data.object_type == 'BRANCH') {
                          //branch
                          if (!branchOfferNext) {
                            return false
                          } else {
                            return true
                          }
                        } else {
                          //items
                          if (!itemOfferNext) {
                            return false
                          } else {
                            return true
                          }
                        }
                      }
                    }}
                    prevValid={() => {
                      if (data.section_type === "REGULAR") {
                        if (data.object_type == "ITEM") {
                          //no op
                          return false
                        } else {
                          if (!branchPrev) {
                            return false
                          } else {
                            return true
                          }
                        }
                      } else {
                        if (data.object_type == 'BRANCH') {
                          //branch
                          if (!branchOfferPrev) {
                            return false
                          } else {
                            return true
                          }
                        } else {
                          //items
                          if (!itemOfferPrev) {
                            return false
                          } else {
                            return true
                          }
                        }
                      }
                    }}
                  />
                  {/* {data.section_type!=="ADS"&& */}
                  {(selectedData.length != 0 && data.section_type !== "ADS" && data.section_type !== "SALE") &&
                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Selected Menus {" "}
                        {/* <span class="required"> * </span>  */}
                        :{" "}
                      </label>
                      <div className="col-sm-9">
                        <div class="row">
                          {
                            selectedData.length > 0 && selectedData.map((item, index) => {
                              return (
                                <div className="col-3" style={{
                                  display: "flex", alignItems: "center", justifyContent: "space-around",
                                  borderRadius: "20px", backgroundColor: "#FB310D", margin: "8px", color: "white"
                                }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <h6 style={{ margin: "6px", color: "white" }}>{
                                      item.name
                                    }</h6>
                                    <span
                                      style={{
                                        fontSize: 16, height: "20px",
                                        width: "20px",
                                        cursor: 'pointer', marginTop: 5, marginLeft: 10, display: 'flex',
                                        alignItems: 'center', justifyContent: 'center', textAlign: 'center',
                                        color: "red", borderRadius: "5px", backgroundColor: "white", float: "right"
                                      }}
                                      onClick={(e) => {
                                        Pop(index)
                                      }}
                                    > <i className="fa fa-trash-o text-danger" style={{ cursor: "pointer" }}></i></span>
                                  </div>

                                </div>
                              )
                            })
                          }
                        </div>

                      </div>
                    </div>}

                  <AddBottomComponent disable={disable || imageError}
                    saveButton={(e) => {
                      e.preventDefault();
                      // alert(JSON.stringify(data.section_type))
                      setdisable(true);
                      setErrors([]);

                      if (data.name === "" && data.section_type !== "ADS") {
                        setdisable(false)
                        setErrors(["Section heading"]);
                        return;
                      }
                      var regExp = /[a-zA-Z]/g;
                     
                      if(!regExp.test(data.name) && data.section_type != "ADS"){
                        setdisable(false)
                        setErrors(["Section heading invalid"]);
                        return;
                      }

                      if (data.icon === "") {
                        setdisable(false)
                        setErrors([data.section_type === "ADS" ? "Ads Image" : "Icon"]);
                        return;
                      }
                      if (data.image_type === "") {
                        setdisable(false)
                        setErrors(["Image Type "]);
                        return;
                      }
                      if (data.url_link && !validURL(data.url_link)) {
                        setdisable(false)
                        setErrors(["Invalid Url "]);
                        return;
                      }

                      if (data.section_type == "") {
                        setdisable(false)
                        setErrors([`choose section type`]);
                        return;
                      }

                      if (data.section_type === "SALE" && is_superuser && data.franchise_id === "") {
                        setdisable(false)
                        setErrors(["Franchise"]);
                        return;
                      }

                      if (data.ids.length === 0 && data.section_type !== "ADS" && data.section_type !== "SALE") {
                        setdisable(false)
                        setErrors([`choose  ${data.section_type === "REGULAR" ? data.object_type === "ITEM" ? "Item" : "Restaurants" : data.object_type === "ITEM" ? "Item" : "Restaurants"}`]);
                        return;
                      }

                      // showMessage("Section validation passed", "success", "Success!", "top", "top-right", 0);
                      // setdisable(false)
                      // void 0
                      // return
                      let res = ManageSection(e, data, "add", "");
                      res.then((res) => {
                        setdisable(false)
                        if (res) {
                          if (res.data.Status === true) {
                            showMessage("Section added", "success", "Success!", "top", "top-right", 0);
                            setData({ ...data, id: "", name: "", bg_image: "", icon: "", is_active: 1, is_blocked: "false", url_link: "",ids:[] });
                            setKey(Date.now());
                            setSelectedData([]);
                            setIds([])
                            // sleep(300);

                            if(data.section_type==="REGULAR" ){
                              fetchBranches();
                            }
                            if(data.section_type==="OFFER"){
                              
                              if(data.object_type==="ITEM"){
                                fetchProductOfferData();
                              }else{
                                fetchBranchOfferData();
                              }
                            }
                            
                          } else {
                            showMessage(res.data.Error, "danger", "Failed!", "top", "top-right", 0);
                          }
                        }
                      });
                    }} />


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddSection() {
  const headers = "Add Section";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default AddSection;
